export enum ActivityState {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum ThemeType {
  DARK = "dark",
  LIGHT = "light",
}
